import React, {PropTypes as T} from 'react';
import Modal, {ModalHeader, ModalContent} from '../../common/modal';
import Button from '../../common/button';
import ModalCloseIcon from '../../common/icons/icon_close2';
import FeeBreakdown from '../feebreakdown';
import withDevice from '../../common/withDeviceHOC';
import {sprintf} from 'sprintf-js';
import noScroll from '../../../utils/noscroll';
import get from 'lodash/get';
import translate from '../../../utils/translate';

export class TicketPriceInfo extends React.Component {
  static propTypes = {
    basket:       T.object,
    deliveryfees: T.object,
    isMobile:     T.bool,
    headerText:   T.string,
    text:         T.object.isRequired
  };

  state = {isHidden: true};

  // TODO: move all these getTicketPrice/Fee... functions into utils/ticketprice

  getTicketFeeString = (feeRange, text, moneyFormat) => {
    const min = feeRange.min;
    const max = feeRange.max;

    if (!min || !max || max.includedCharge === 0) {
      return '';
    }

    if (min.includedCharge === 0) {
      const total    = max.includedCharge / 100;
      const decimals = Math.round((total % 1) * 100);
      const minFormatted = sprintf(moneyFormat, 0, 0, '');
      const maxFormatted = sprintf(moneyFormat, total, decimals, text.currency);
      return `${minFormatted} - ${maxFormatted}`;
    }

    if (min.includedCharge === max.includedCharge) {
      const total    = max.includedCharge / 100;
      const decimals = Math.round((total % 1) * 100);
      return sprintf(moneyFormat, total, decimals, text.currency);
    }
    else {
      const minTotal    = min.includedCharge / 100;
      const minDecimals = Math.round((minTotal % 1) * 100);
      const maxTotal    = max.includedCharge / 100;
      const maxDecimals = Math.round((maxTotal % 1) * 100);
      const minFormatted = sprintf(moneyFormat, minTotal, minDecimals, '');
      const maxFormatted = sprintf(moneyFormat, maxTotal, maxDecimals, text.currency);
      return `${minFormatted} - ${maxFormatted}`;
    }
  };

  getTicketFeeRange = (feeObjArray) => {
    const sorted = feeObjArray.sort((a, b) => {
      if (a.includedCharge < b.includedCharge) return -1;
      if (a.includedCharge > b.includedCharge) return 1;
      return 0;
    });

    return {min: sorted[0], max: sorted[sorted.length - 1]};
  };

  open = () => {
    this.setState({isHidden: false});
  };

  close = () => {
    noScroll.off();
    this.setState({isHidden: true});
  };

  renderHeader = (headerText) => {
    if (headerText) {
      return (
        <h2 className="ticketpriceinfo__heading" data-component={this.props.isMobile ? 'ticketprice' : undefined}>
          {headerText}
        </h2>
      );
    }
    else {
      return false;
    }
  };

  renderFees = (text) => {
    return (
      <p className="ticketpriceinfo__text" data-component="ticketfee">
        <span data-component="ticketfeeinfo-fee">{text.ticketServiceFee}</span>
      </p>
    );
  };

  renderFeesBreakdown = (text, ticketFeeRange) => {
    return (
      <p className="ticketpriceinfo__text" data-component="ticketfee">
        <span data-component="ticketfeeinfo-feeprefix">{text.serviceFeePrefix} </span>
        {this.getTicketFeeString(ticketFeeRange, text, this.props.basket.moneyFormat)}
        <span data-component="ticketfeeinfo-feesuffix"> {text.serviceFeeSuffix}</span>
      </p>
    );
  };

  renderDeliveryFeeInfoText = (text, link) => {
    return this.props.basket.showDeliveryFees &&
      <p className="ticketpriceinfo__text" data-component="ticketdeliveryfeeinfo">
        {text.deliveryFeeInfo + '\u00A0'}
        {link}
      </p>;
  }

  renderPaymentFeeInfoText = (text) => {
    return text.paymentFeeInfo &&
      <p className="ticketpriceinfo__text" data-component="ticketpaymentfeeinfo"
        dangerouslySetInnerHTML={{__html: text.paymentFeeInfo}} />;
  }

  renderDeliveryInfo = (showDeliveryFee, deliveryFees) => {
    if (showDeliveryFee && deliveryFees.fees.length > 0) {
      return (
        <button
          id="ticketpriceinfo__infobtn"
          type="button"
          onClick={this.open}
          className="ticketpriceinfo__infobtn"
          data-component="deliveryFeeLink"
        >
          {translate('deliveryFeeModule', 'DELIVERY_COSTS_LINK_TEXT') + '\u00A0'}
        </button>
      );
    }
    else {
      return false;
    }
  };

  renderUnoc = () => {
    if (this.props.deliveryfees && this.props.deliveryfees.unoc instanceof Error) {
      return null;
    }

    const unocDescriptionWithAmount = translate('uniqueOrderChargeModule', 'UNOC_DESCRIPTION_WITH_AMOUNT');
    if (
      unocDescriptionWithAmount &&
      unocDescriptionWithAmount !== '' &&
      unocDescriptionWithAmount !== 'Textunit (UNOC_DESCRIPTION_WITH_AMOUNT) not found') {
      return (
        <p className="ticketpriceinfo__text unoc" data-component="unoc">
          {unocDescriptionWithAmount}
        </p>
      );
    }
    return null;
  };

  renderFeeInformationTitle = (text, fees, deliveryFeeInfoText, paymentInfoText) => {
    if (fees === '' && deliveryFeeInfoText === '' && paymentInfoText === '') { return ''; }
    return (
      <div>
        <p className="ticketpriceinfo__text feeinformation__text">{text}</p>
      </div>
    );
  }


  render () {
    const text = this.props.text;
    const ticketFeeRange = this.getTicketFeeRange(this.props.basket.prices);

    let fees = this.props.basket.showServiceFeeBreakdown
               ? this.renderFeesBreakdown(text, ticketFeeRange)
               : this.renderFees(text);

    const includedCharge = get(ticketFeeRange, 'max.includedCharge', null);
    if (includedCharge === 0) {
      fees = undefined;
    }
    const feeInfoText = translate('ticketPriceInformationModule', 'FEE_INFORMATION');
    const infoLink = this.renderDeliveryInfo(this.props.basket.showDeliveryFees, this.props.deliveryfees);
    const deliveryFeeInfoText = this.renderDeliveryFeeInfoText(text, infoLink);
    const paymentInfoText = this.renderPaymentFeeInfoText(text);
    const unoc = this.renderUnoc();
    const hasFeeInfo = fees || unoc || deliveryFeeInfoText;
    const hasPriceInfo = hasFeeInfo || paymentInfoText || this.props.basket.showDeliveryFees;

    return (
      <div className="ticketpriceinfo" data-component="ticketpriceinfo">

        { hasPriceInfo &&
        <div className="ticketpriceinfo__content">
          {this.renderHeader(this.props.headerText)}
          <div className="ticketpriceinfo__details">
            <div className="ticketpriceinfo__paragraphs">
              {this.props.basket.showDeliveryFees &&
              this.renderFeeInformationTitle(feeInfoText, fees, deliveryFeeInfoText, paymentInfoText)}
              {hasFeeInfo &&
              <p className="ticketpriceinfo__paragraph">
                {fees}
                {unoc}
                {deliveryFeeInfoText}
              </p>
              }
              { paymentInfoText && <p className="ticketpriceinfo__paragraph">
                {paymentInfoText}
              </p>
              }
            </div>
          </div>
        </div>
        }

        {
          this.props.basket.showDeliveryFees && !this.state.isHidden &&
          <Modal
            onClose={this.close}
            isOpen={!this.state.isHidden}
            dataComponent="delivery-costs-modal">
            <ModalHeader isInfo>
              <div className="modal__header_title">{text.deliveryCosts}</div>
              <Button icon onClick={this.close} data-component="modal__close_button">
                <ModalCloseIcon className="modal__header__close_icon" />
              </Button>
            </ModalHeader>

            <ModalContent seamless>
              <FeeBreakdown fees={this.props.deliveryfees.fees} />
            </ModalContent>
          </Modal>
        }
      </div>
    );
  }
}

export default withDevice(TicketPriceInfo);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/ticketpriceinfo/index.js